import styled from "@emotion/styled";

const PageBadge = styled.button(({ theme }) => ({
  display: "inline-block",
  alignSelf: "flex-start",
  background: "none",
  border: "none",
  borderRadius: 0,
  padding: 0,
  fontSize: 12,
  fontWeight: 600,
  color: theme.colors.sysPrimaryDefault,
  cursor: "pointer",
  whiteSpace: "nowrap",
  textDecoration: "underline",
  "&:hover": {
    color: theme.colors.sysPrimaryHover,
  },
}));

export default PageBadge;
